import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcPlaceholder = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-icon-accent)",
  height: "8",
  rx: "2",
  width: "8",
  x: "3",
  y: "3"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-icon-weak)",
  height: "8",
  rx: "2",
  width: "8",
  x: "3",
  y: "13"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-icon-medium)",
  height: "8",
  rx: "2",
  width: "8",
  x: "13",
  y: "3"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-border-medium)",
  height: "8",
  rx: "2",
  width: "8",
  x: "13",
  y: "13"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-border-strong)",
  height: "8",
  rx: "2",
  width: "8",
  x: "8",
  y: "7"
})), "IcPlaceholder");

export { IcPlaceholder };
//# sourceMappingURL=ic-placeholder.js.map
